import L from "leaflet"
import Logger from "@utils/logger";

export enum FigureEnum {
  POLYGON = "Polygon",
  MARKER = "Marker"
}

type EventsType = {
  create: (a: any) => void,
  update: (a: any) => void,
  save: () => void
}

type FiguresType = { [key in FigureEnum]: { type: FigureEnum, data: any, layer: any } }

// const baseFigures = {
//   [FigureEnum.MARKER]: {
//     type: FigureEnum.MARKER,
//     figure: {},
//   },
//   [FigureEnum.POLYGON]: {
//     type: FigureEnum.POLYGON,
//     figure: {},
//   }
// }
const log = Logger.getLogger("drawer")
class Drawer {
  map: any
  figures: FiguresType = {} as FiguresType
  events: EventsType | any
  suffix = () => Math.floor(Math.random() * 1000);
  
  constructor(map: any) {
    this.map = map
    this.init = this.init.bind(this)
    this.disableDraw = this.disableDraw.bind(this)
    this.createEditor = this.createEditor.bind(this)
    this.hangEvents = this.hangEvents.bind(this)
    this.handlerOnClick = this.handlerOnClick.bind(this)
    this.handlerSerialize = this.handlerSerialize.bind(this)
  }
  
  
  init = ({events}: { events: EventsType }) => {
    this.events = events
    let {save} = this.events
    
    
    this.map.pm.setLang('ru');
    this.map.on("pm:create", (e: any) => {
      let {shape: type} = e
      
      switch (type) {
        case FigureEnum.POLYGON: {
          //@ts-ignore
          let copyDataFigure = this.figures[type]
          let copyLayer = e.layer
          if (copyDataFigure) {
            copyDataFigure.layers.push(copyLayer)
          } else {
            copyDataFigure = {type, data: {glid: this.suffix()}, layers: [copyLayer]}
            this.figures = {[type]: copyDataFigure} as FiguresType
          }
          
          this.hangEvents()
          break;
        }
      }
    }, this);
    
    this.map.on("pm:remove", (e: any) => {
      let {shape: type} = e
      //@ts-ignore
      this.figures[type].layers = this.figures[type].layers.filter((layer: any) => layer._leaflet_id !== e.layer._leaflet_id)
    }, this)
    
    this.map.pm.Toolbar.createCustomControl({
      name: "Save",
      title: "Сохранение",
      className: ""
    });
    
  }
  
  handlerOnClick() {
    // @ts-ignore
    this.events.save(this.handlerSerialize(this.figures))
    this.disableDraw()
  }
  
  handlerSerialize = (element: any) => {
    
    for (let item in element) {
      let {data, layers, type} = element[item]
      switch (type) {
        case FigureEnum.POLYGON: {
          
          return {
            ...data,
            geometry: {
              ...data.geometry,
              coordinates: layers.map((layer: any) => layer.getLatLngs())
            }
          }
        }
      }
    }
    
    return {}
  }
  
  hangEvents() {
    const self = this
    for (let figureName in this.figures) {
      
      //@ts-ignore
      self.figures[figureName].layers.forEach((layer: any) => {
        layer.on("pm:update", (e: any) => {
          let {shape: type} = e
          switch (type) {
            case FigureEnum.POLYGON: {
              //@ts-ignore
              self.figures[figureName].layers.forEach((lay: any) => {
                if (lay._leaflet_id === layer._leaflet_id) {
                  lay = e.layer
                }
              })
              break;
            }
          }
          this.hangEvents()
        }, this);
        layer.on("pm:cut", (e: any) => {
          let {target: {pm: {_shape: type}}} = e
          switch (type) {
            case FigureEnum.POLYGON: {
              //@ts-ignore
              this.figures[figureName].layers = this.figures[figureName].layers.map((lay: any) => lay._leaflet_id === layer._leaflet_id ? e.layer : lay)
              break;
            }
          }
          this.hangEvents()
        }, this)
      }, this)
    }
  }
  
  
  createEditor = (props?: any) => {
    log.debug("Create editor", props)
    this.map.pm.enableDraw();
    
    let {type, data} = props
    
    switch (type) {
      case FigureEnum.POLYGON: {
        if (Object.entries(data).length) {
          let layers: any[] = data.geometry.coordinates.map((i: any) => {
            let layer = new L.Polygon(i.map((i: any[]) => [i[1], i[0]]))
            //@ts-ignore
            layer.uniq = this.suffix()
            layer.addTo(this.map)
            return layer
          })
          let copyDataFigure = {type, data, layers}
          this.figures = {[type]: copyDataFigure} as FiguresType
        }
        break;
      }
      case FigureEnum.MARKER: {
        break;
      }
    }
    
    this.hangEvents()
    
    
    const actions = [
      {
        text: 'Сохранить',
        onClick: this.handlerOnClick
      },
    ];
    
    this.map.pm.Toolbar.changeActionsOfControl("Save", actions)
    
    
    this.map.pm.addControls({
      position: 'topright',
      drawControls: true,
      drawEdit: true,
      drawPolygon: type === FigureEnum.POLYGON,
      drawMarker: type === FigureEnum.MARKER,
      drawCircleMarker: false,
      drawPolyline: false,
      drawRectangle: false,
      drawCircle: false,
      drawText: false,
      cutPolygon: type === FigureEnum.POLYGON,
      customControls: true,
      oneBlock: true
    });
    
    
    this.map.pm.enableDraw(type, {snappable: true, snapDistance: 20,});
  }
  
  disableDraw() {
    this.map.eachLayer((layer: any) => {
      
      if (layer._latlngs || layer._latlng) this.map.removeLayer(layer)
    }, this);
    
    this.figures = {} as FiguresType
    this.map.pm.disableDraw();
    this.map.pm.removeControls()
  }
}

export default Drawer;